import React, { useMemo } from 'react';
import { Typography } from '../../Typography';
import { optionLabel } from '../utils';
// show selected value, could be single value or multiple values
export var ValueContainer = function ValueContainer(_ref) {
  var value = _ref.value,
      getOptionLabel = _ref.getOptionLabel;
  var selectedValueLabel = useMemo(function () {
    return Array.isArray(value) ? value.map(function (item) {
      return optionLabel(item, getOptionLabel);
    }).join(',') : value && optionLabel(value, getOptionLabel);
  }, [getOptionLabel, value]);
  return /*#__PURE__*/React.createElement(Typography, {
    "data-test": "select-value-container",
    variant: "body2",
    ellipsis: true
  }, selectedValueLabel);
};